import { Component, Input, OnInit } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
})
export class SkeletonLoaderComponent implements OnInit {
  @Input() margin: string = '0';
  @Input() height: string = '100%';
  @Input() width: string = '100%';
  @Input() radius: string = '6px';
  @Input() color: string = '#eff1f6';
  @Input() padding: string = '0';
  @Input() fill: boolean = false;
  @Input() ratio: number | undefined;

  constructor() {}

  ngOnInit(): void {}
}
